<template>
  <div>
    <data-grid-view v-if="viewType === 0" :viewId="viewId" :viewConfig="viewConfig" />
    <pivot-grid-view v-else-if="viewType === 1" :viewId="viewId" :viewConfig="viewConfig" />
    <map-view v-else-if="viewType === 2" :viewId="viewId" :viewConfig="viewConfig" />
    <chart-view v-else-if="viewType === 3" :viewId="viewId" :viewConfig="viewConfig" />
  </div>
</template>

<script>
import DataGridView from "./DataGridView.vue";
import PivotGridView from "./PivotGridView.vue";
import MapView from "./MapView.vue";
import ChartView from "./ChartView.vue";

import Api from "@/api";

export default {
  props: ["viewId", "viewType"],
  components: { DataGridView, PivotGridView, MapView, ChartView },
  data: () => ({
    isLoading: false,
    viewConfig: {}
  }),
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;

      Api.getViewConfig(this.viewId)
        .then((response) => this.viewConfig = response)
        .catch((error) => this.$eventHub.emit(error))
        .finally(() => this.isLoading = false);
    }
  }
}
</script>